module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FscXVlXzEiIGRhdGEtbmFtZT0iQ2FscXVlIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDIwIDI0Ij48dGl0bGU+cGxheTwvdGl0bGU+PHBvbHlnb24gcG9pbnRzPSIxIDEuNzcgMTguMDYgMTIgMSAyMi4yMyAxIDEuNzciIHN0eWxlPSJmaWxsOiNmZmYiLz48cGF0aCBkPSJNMiwzLjUzLDE2LjExLDEyLDIsMjAuNDdWMy41M00wLDBWMjRMMjAsMTIsMCwwWiIgc3R5bGU9ImZpbGw6I2ZmZiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/play.svg
// module id = cHMr
// module chunks = 1